import { useFlags } from 'launchdarkly-react-client-sdk'
import { safeLocalStorage } from '../../../../../../utils/safeStorage'
import ComponentStyles from './styles'

const userData = safeLocalStorage.getJSONItem('userData')
const { UnifiBanner } = ComponentStyles

export const TempUnifiNotification = () => {
  const featureFlags = useFlags()
  if (!featureFlags.f22465UnifiBanner) {
    return null
  }
  const unifiBannerCompanies = ['Unifi Service', '(PRD) Unifi', '(STG) Unifi', '(QA) Unifi']

  const showTempUnifiNotification = unifiBannerCompanies.includes(userData?.activeNetwork.DBAName)

  return (
    showTempUnifiNotification && (
      <UnifiBanner>
        <div className="main-container">
          <div className="text-container">            
            <i className="far fa-exclamation-triangle warning-icon" />
            Attention: DCG is no longer available through Raiven. Updated ordering instructions will be provided soon. In
            the meantime, please contact{' '}
            <a href="mailto:Kristal.BrownStephenson@unifiservice.com">Kristal.BrownStephenson@unifiservice.com</a> to place a
            DCG order.
          </div>
        </div>
      </UnifiBanner>
    )
  )
}

export default TempUnifiNotification
